import React from 'react';
import ReactQuill from 'react-quill';

import './style.less';

// https://quilljs.com/docs/modules/toolbar/
// NOTE: If you add stuff here, make sure to update styling and isEmpty!!
const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

const isEmpty = (value) => !value?.replace(/(<([^>]+)>)/gi, '').trim();

const RichTextInput = ({ className, onChange, ...props }) => {
  let classNames = 'rich-text-input';
  if (className) {
    classNames += ` ${className}`;
  }

  // Only propagate changes made by the user
  const onChangeHandler = (content, delta, source) => {
    if (source === 'user') {
      onChange(isEmpty(content) ? null : content);
    }
  };

  return <ReactQuill className={classNames} modules={modules} onChange={onChangeHandler} {...props} />;
};

export default RichTextInput;
